import OrderDetailsModal from "../../../../Components/modals/OrderDetails/OrderDetailsModal";
import ConfirmationModal from "./ConfirmationModal";
import AssignPickerModal from "./AssignPickerModal";

const OrdersModalManager = ({
  open,
  handleClose,
  selectedOrder,
  showReleaseOrdersDialog,
  setShowReleaseOrdersDialog,
  selectedJobIds,
  type,
  isSubmitting,
  handleConfirmReleaseOrders,
  pickers,
  showAssignPickerDialog,
  setShowAssignPickerDialog,
  fetchOrders,
  setSelectedJobIds,
  showMarkAsCompletedDialog,
  setShowMarkAsCompletedDialog,
  isSubmittingMarkAsCompleted,
  handleMarkAsCompleted,
}) => {
  const relseaseOrderMessage = (
    <>
      Are you sure you want to release following{" "}
      {selectedJobIds.length === 1 ? "order" : "orders"}?
    </>
  );

  const markAsCompletedMessage = (
    <>
      Are you sure you want to mark following{" "}
      {selectedJobIds.length === 1 ? "order" : "orders"} as completed?
    </>
  );

  return (
    <>
      {open && (
        <OrderDetailsModal
          open={open}
          handleClose={handleClose}
          selectedOrder={selectedOrder}
        />
      )}
      {showReleaseOrdersDialog && (
        <ConfirmationModal
          open={showReleaseOrdersDialog}
          handleClose={() => setShowReleaseOrdersDialog(false)}
          jobIds={selectedJobIds}
          title={`Release Order${selectedJobIds.length > 1 ? "s" : ""}`}
          message={relseaseOrderMessage}
          onConfirm={() => {
            handleConfirmReleaseOrders();
            setShowReleaseOrdersDialog(false);
          }}
          actionLoadingText="Please wait..."
          ActionBtnText={`Yes, Release ${
            selectedJobIds.length === 1 ? "Order" : "Orders"
          }`}
          loading={isSubmitting}
        />
      )}
      {showAssignPickerDialog && (
        <AssignPickerModal
          open={showAssignPickerDialog}
          onClose={() => setShowAssignPickerDialog(false)}
          title={
            type === "in-queue"
              ? "Assign Picker"
              : `Release Order${selectedJobIds.length > 1 ? "s" : ""}${
                  type === "delay-picking" ? " and Assign Picker" : ""
                }`
          }
          jobIds={selectedJobIds}
          pickers={pickers}
          onAssignSuccess={() => {
            fetchOrders();
            setSelectedJobIds([]);
            setShowAssignPickerDialog(false);
          }}
        />
      )}
      {showMarkAsCompletedDialog && (
        <ConfirmationModal
          open={showMarkAsCompletedDialog}
          handleClose={() => {
            setShowMarkAsCompletedDialog(false);
            // setIsSubmittingMarkAsCompleted(false); // This is handled in the parent
          }}
          jobIds={selectedJobIds}
          title={"Mark as Completed"}
          message={markAsCompletedMessage}
          onConfirm={() => {
            handleMarkAsCompleted();
            setShowMarkAsCompletedDialog(false);
          }}
          actionLoadingText="Please wait..."
          ActionBtnText="Yes, Mark as Completed"
          loading={isSubmittingMarkAsCompleted}
        />
      )}
    </>
  );
};

export default OrdersModalManager;
